// extracted by mini-css-extract-plugin
export default {"swing":"swing_swing__Quc3C","spin":"swing_spin__ybxaQ"};